import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TimeUnit } from "@models/enums/time-unit.enum";
import { PlanType } from "@models/enums/plan-type.enum";
import { FormGroup } from "@angular/forms";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-time-unit-picker',
    templateUrl: './time-unit-picker.component.html',
    styleUrls: ['./time-unit-picker.component.scss']
})
export class TimeUnitPickerComponent implements OnInit {
    public readonly TimeUnit = TimeUnit;

    @Output() selectUnit = new EventEmitter<any>();

    @Input() unit: any;

    constructor() {
    }

    ngOnInit() {

    }

    onSelectUnit(value: TimeUnit) {
        this.selectUnit.emit(value);
    }
}
